<template>
<div class="team-module">
  <div class="module-title clearfix">
    <div class="module-title-img">
      <slot name="title-img"></slot>
    </div>
    <div class="module-title-text">
      <slot name="title-text"></slot>
    </div>
  </div>
  <div class="module-body">
    <div class="nkn-position">
      <slot name="position"></slot>
    </div>
    <div class="person-detail" :class="[{'person-detail-en': lang === 'en'}, {'person-detail-zh': lang === 'zh'}]">
      <slot name="detail"></slot>
    </div>
  </div>
  <div class="module-bottom">
    <slot name="github"></slot>
    <slot name="linkedin"></slot>
  </div>
</div>
</template>

<script>
export default {
  computed: {
    lang() {
      return this.$i18n.locale
    }
  }
}
</script>

<style lang="scss" scoped>
.team-module {
  width: 13rem;
  height: 26rem;
  padding: 1rem 1.3rem 1rem 1rem;
  position: relative;
  float: left;
  box-sizing: border-box;
  box-shadow: 0 0 .15rem 0 #d6dbee;

  @media screen and (max-width: 768px) {
    width: 12.5rem;
    height: 450px;
    margin-top: 2rem;
  }

  &:hover {
    box-shadow: 0 0 .4rem .1rem #d6dbee;
  }

  .module-title {
    padding: 1.3rem 0;
    margin-right: -.8rem;
    border-bottom: 1px solid #bbc1d3;
    @include nkn-font-set(.9rem, $common-color);
    white-space: nowrap;

    &-img {
      float: left;
    }

    &-text {
      float: left;
      margin-left: .8rem;
      font-weight: 600;
      margin-top: 2.25rem;
    }
  }

  .module-body {
    margin-top: 1rem;
    width: 11.5rem;

    .nkn-position {
      @include nkn-font-set(.7rem, #1791f2);
      line-height: 1rem;
    }

    .person-detail {
      @include nkn-font-set(.7rem, currentColor, 400);
      margin-top: .5rem;
      line-height: 1rem;
      white-space: pre-line;

      &-en {
        word-break: keep-all;
      }

      &-zh {
        word-break: break-all;
      }
    }

  }

  .module-bottom {
    position: absolute;
    bottom: 20px;
    left: 20px;

    & a {
      color: #bbced3;
      margin-right: 1.5rem;

      & i {
        font-size: 1.2rem;

        &:hover {
          color: #1791f2;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/plugins/TeamModule.vue